<mat-accordion *ngIf="(invitedGuestStore.invitedGuests | store).size" multi>
  <mat-expansion-panel *ngFor="let guest of invitedGuestStore.getInvitedGuests(eventId ?? '')">
    <mat-expansion-panel-header>
      <mat-panel-title>{{guest.id}}</mat-panel-title>
    </mat-expansion-panel-header>
    <p>{{guest.email}}</p>
  </mat-expansion-panel>
</mat-accordion>
